/**
 * This function constructs a query string from the provided parameters for hydration links.
 * @param {Object} parameterObject
 * @returns {string} A query string containing all available parameters.
 */
const includeAvailableUriParameters = (parameterObject = {}) => {
  const {
    catalogId,
    storeId,
    langId,
    brand,
    store,
    currency,
    country,
    urlRoot,
    segment,
    storePreview,
    aemContentAuthoring,
  } = parameterObject;

  const parameterArray = [];

  if (catalogId) parameterArray.push(`catalogId=${catalogId}`);
  if (storeId) parameterArray.push(`storeId=${storeId}`);
  if (langId) parameterArray.push(`langId=${langId}`);
  if (brand) parameterArray.push(`brand=${brand}`);
  if (store) parameterArray.push(`store=${store}`);
  if (currency) parameterArray.push(`currency=${currency}`);
  if (country) parameterArray.push(`country=${country}`);
  if (urlRoot) parameterArray.push(`urlRoot=${urlRoot}`);
  if (segment) parameterArray.push(`segment=${segment}`);
  if (storePreview) parameterArray.push(`storePreview=${storePreview}`);
  if (aemContentAuthoring) parameterArray.push(`aemContentAuthoring=${aemContentAuthoring}`);

  return parameterArray.join('&');
};

export default includeAvailableUriParameters;
